module.exports = __webpack_public_path__ + "static/img/shizhong.4344b604.png";